import moment from 'moment'
import Quasar, { LocalStorage } from 'quasar'
import { boot } from 'quasar/wrappers'
import Vue from 'vue'
import VueI18n from 'vue-i18n'

declare module 'vue/types/vue' {
  interface Vue {
    i18n: VueI18n
  }
}

Vue.use(VueI18n)

const requireAll = (r: any) => Object.fromEntries(
  r.keys().map(
    (key: string) => {
      const isoName = key.replace('./', '').split('.')[0]
      const msgs = r(key).default
      return [isoName === 'en' ? 'en-us' : isoName, msgs]
    },
  ),
)

const detectedLocale = Quasar.lang.getLocale()?.split('-')[0] ?? 'en-us'
const locale = LocalStorage.getItem<string>('locale') ?? detectedLocale
moment.locale(locale)

export const i18n = new VueI18n({
  locale,
  fallbackLocale: 'en-us',
  // @ts-expect-error a maron
  // eslint-disable-next-line unicorn/prefer-module
  messages: requireAll(require.context('app/locales/', true, /\.yaml$/)),
})

export default boot(async ({ app }) => {
  app.i18n = i18n

  const quasarLang = locale === 'en' ? 'en-us' : locale
  Quasar.lang.set(
    (await import(
      /* webpackInclude: /(es|it|pt|en-us|de)\.js$/ */
      `quasar/lang/${quasarLang}`
    // eslint-disable-next-line unicorn/no-await-expression-member
    )).default,
  )
})
